import { useCallback } from 'react';
import { callDeepLink, isBrowser } from '@croquiscom/web2app';

import { useAppConfig } from '@common/app-config';
import { useToggle } from '@common/hooks';
import { EXCEPTION_SALE_TYPE_LIST, PdpProductEntryType, useCatalogProductIdParams } from '@domains/pdp-common';
import { FocusTabHashKey } from '@domains/pdp-common';

import { useContactInfo } from '../queries/useContactInfoQuery';

interface UseEssentialsOptions {
  is_opened: boolean;
}

export const useProductInfoProvidedNoticeService = (options?: UseEssentialsOptions) => {
  const params = useCatalogProductIdParams();
  const {
    product: { essentials, entry_type, external_product_url },
    shop: { sale_type },
  } = useContactInfo(params);

  const { isZigzagApp } = useAppConfig();
  const [is_opened, toggle] = useToggle(options?.is_opened);

  const show_policy_responsibility = !EXCEPTION_SALE_TYPE_LIST.has(sale_type ?? '');

  const show_essentials = essentials && essentials.length > 0;
  const show_product_information = entry_type !== PdpProductEntryType.DIRECT;

  const moveToMetaPdp = useCallback(() => {
    if (!external_product_url) {
      return;
    }

    if (isBrowser() && !isZigzagApp) {
      window.open(external_product_url);
      return;
    }

    callDeepLink(external_product_url)();
  }, [external_product_url, isZigzagApp]);

  const onClickInquiry = () => {
    window.location.hash = FocusTabHashKey;
  };
  return {
    essentials,
    show_essentials,
    is_opened,
    moveToMetaPdp,
    show_product_information,
    show_policy_responsibility,
    handleOpened: toggle,
    onClickInquiry,
  };
};
